import { Injectable, signal } from "@angular/core";

import { RelatedProductsComponent } from "@components/products/related-products/related-products.component";
import { OverlayCommonService } from "@components/shared/overlay/overlay-common.service";

@Injectable({
  providedIn: "root",
})
export class ProductOverlayService extends OverlayCommonService {
  public relatedProductsCounter = signal<number>(0);

  constructor() {
    super();
  }

  override setCountersToLoadingState() {
    super.setCountersToLoadingState();
    this.relatedProductsCounter.set(null);
  }

  override setCountersEmptyState() {
    super.setCountersEmptyState();
    this.relatedProductsCounter.set(0);
  }

  async loadRelatedProductsCounter(
    productId: string,
    relatedProductsComponent: RelatedProductsComponent,
  ): Promise<void> {
    relatedProductsComponent.productId = productId;
    await relatedProductsComponent.reloadProductsData(true);

    const count =
      relatedProductsComponent.createdFromProducts.length +
      relatedProductsComponent.usedInProducts.length;

    this.relatedProductsCounter.set(count);
  }
}
